import { setStateAndLocalStorage, getFromLocalStorage, setStateAndSession, getFromStateAndSession } from '@/utils/storage';

const label = {
  namespaced: true,
  state: {
    subNoListObj: getFromLocalStorage('subNoListObj') || {},
    binLevelObj: getFromLocalStorage('binLevelObj') || {},
    machineHandNoObj: getFromLocalStorage('machineHandNoObj') || {},
    labelPrintCountObj: getFromLocalStorage('labelPrintCountObj') || {},
    queryMachineHandNoUsedObj: getFromStateAndSession('queryMachineHandNoUsedObj') || {},
  },
  mutations: {
    saveSubNoListObj(state, subNoListObj) {
      setStateAndLocalStorage(state, 'subNoListObj', subNoListObj);
    },
    saveBinLevelObj(state, binLevelObj) {
      setStateAndLocalStorage(state, 'binLevelObj', binLevelObj);
    },
    saveMachineHandNoObj(state, machineHandNoObj) {
      setStateAndLocalStorage(state, 'machineHandNoObj', machineHandNoObj);
    },
    saveLabelPrintCountObj(state, labelPrintCountObj) {
      setStateAndLocalStorage(state, 'labelPrintCountObj', labelPrintCountObj);
    },
    saveQueryMachineHandNoUsedObj(state, queryMachineHandNoUsedObj) {
      setStateAndSession(state, 'queryMachineHandNoUsedObj', queryMachineHandNoUsedObj);
    }
  },
};

export default label;
